import type { Media } from '../flotiq-client/types/api-response';

import { createStore } from '@xstate/store-react';

export type NewMediaState = 'uploading' | 'uploaded' | 'unsplash' | 'error';

export interface FileWithId extends File {
  id: number;
}

export type NewMediaObject =
  | {
      media: Media;
      state: 'uploaded' | 'unsplash';
      error?: string;
    }
  | {
      media: FileWithId | { id: string };
      state: 'uploading' | 'error';
      error?: string;
    };

const isMedia = (
  newMedia: Media | FileWithId | { id: string },
  state: NewMediaState,
): newMedia is Media => state === 'unsplash' || state === 'uploaded';

export const newMediaStore = createStore({
  context: { newMedia: [] as NewMediaObject[] },
  on: {
    removeNewMedia: (context) => ({
      newMedia: context.newMedia.filter(({ state }) => state === 'uploading'),
    }),
    updateNewMedia: (context, { newMedia }: { newMedia: NewMediaObject[] }) => {
      const newList = [...context.newMedia];
      newMedia.forEach((uploadedMedia) => {
        const { media, state } = uploadedMedia;
        const index = newList.findIndex(
          ({ media: oldMedia, state: oldState }) => {
            if (state === 'unsplash')
              return (
                oldMedia['id'] === media['externalId'] ||
                (isMedia(oldMedia, oldState) &&
                  oldMedia['externalId'] === media['externalId'])
              );
            if (state === 'uploaded')
              return (
                'name' in oldMedia && oldMedia['name'] === media['fileName']
              );
            return oldMedia['id'] === media['id'];
          },
        );
        if (index > -1) newList[index] = uploadedMedia;
        else newList.push(uploadedMedia);
      });
      return { newMedia: newList };
    },
    clear: () => ({ newMedia: [] }),
  },
});
